import { useTranslation } from "react-i18next";
import { BellRing, CheckCircle2, XCircle } from "lucide-react";
import { NeuCard } from "../../../components/neu/Neu";

// صحة قنوات التذكير: مفتاح الدفع + آخر تشغيل لكل مهمة مجدولة (اكتشاف الانقطاع في دقائق).
export const NotifyHealthCard = ({ data }) => {
  const { t } = useTranslation();
  if (!data) return null;

  const rows = [
    ["push", data.push_enabled ? t("notifyHealth.on") : data.push_reason],
    ["devices", data.devices],
    ["reminders24h", data.reminders_24h],
  ];

  return (
    <NeuCard data-testid="notify-health-card">
      <div className="flex items-center justify-between gap-3">
        <p className="label-xs flex items-center gap-2">
          <BellRing className="h-4 w-4 text-primary" /> {t("notifyHealth.title")}
        </p>
        <span
          className={`text-xs font-bold ${data.ok ? "text-success" : "text-destructive"}`}
          data-testid="notify-health-flag"
        >
          {data.ok ? t("notifyHealth.ok") : t("notifyHealth.down")}
        </span>
      </div>

      <div className="mt-4 grid grid-cols-3 gap-3">
        {rows.map(([key, value]) => (
          <div key={key} className="neu-in rounded-2xl p-3" data-testid={`notify-health-${key}`}>
            <p className="text-[10px] tracking-normal text-muted-foreground">{t(`notifyHealth.${key}`)}</p>
            <p className="mt-1 truncate font-mono text-sm font-semibold num">{value}</p>
          </div>
        ))}
      </div>

      <ul className="mt-4 grid gap-2" data-testid="notify-health-jobs">
        {(data.jobs || []).map((job) => (
          <li key={job.job} className="flex items-center justify-between gap-3 rounded-2xl bg-background px-3 py-2.5 shadow-neu-sm">
            <p className="flex items-center gap-2 truncate text-xs font-bold">
              {job.stale ? (
                <XCircle className="h-4 w-4 shrink-0 text-destructive" />
              ) : (
                <CheckCircle2 className="h-4 w-4 shrink-0 text-primary" />
              )}
              {job.job}
            </p>
            <p className="shrink-0 font-mono text-[10px] text-muted-foreground num">
              {job.minutes_ago === null
                ? t("notifyHealth.never")
                : t("notifyHealth.minutesAgo", { count: job.minutes_ago })}
            </p>
          </li>
        ))}
      </ul>
    </NeuCard>
  );
};
